import { createAsyncThunk } from '@reduxjs/toolkit';

// Procurement Status Data Thunk
export const getProcurementStatusData = createAsyncThunk(
  'dashboardProcurement/getProcurementStatusData',
  async () => {
    // TODO: Replace with actual API endpoint
    // const response = await fetch('/api/procurement/status-summary');
    // const data = await response.json();

    // Mock data for now
    const mockData = [
      { title: 'Total Plan Draft', count: 45, status: 'draft', type: 'plan' },
      {
        title: 'Total Plan Submitted',
        count: 78,
        status: 'submitted',
        type: 'plan',
      },
      {
        title: 'Total Procurement Draft',
        count: 32,
        status: 'draft',
        type: 'procurement',
      },
      {
        title: 'Total Procurement Submitted',
        count: 89,
        status: 'submitted',
        type: 'procurement',
      },
    ];

    return mockData;
  }
);

// Product Type Data Thunk
export const getProductTypeData = createAsyncThunk(
  'dashboardProcurement/getProductTypeData',
  async () => {
    // TODO: Replace with actual API endpoint
    // const response = await fetch('/api/procurement/product-type-summary');
    // const data = await response.json();

    // Mock data for now
    const mockData = {
      series: [44, 55, 41, 17, 15],
      labels: ['Fuel', 'Petrochemical', 'LPG', 'Lubricant', 'Others'],
    };

    return mockData;
  }
);

// Procurement Type Data Thunk
export const getProcurementTypeData = createAsyncThunk(
  'dashboardProcurement/getProcurementTypeData',
  async () => {
    // TODO: Replace with actual API endpoint
    // const response = await fetch('/api/procurement/type-summary');
    // const data = await response.json();

    // Mock data for now
    const mockData = {
      series: [
        {
          name: 'Procurement Count',
          data: [65, 45, 78, 32, 89, 25],
        },
      ],
      categories: [
        'Direct Purchase',
        'Tender',
        'E-Auction',
        'Framework Agreement',
        'Emergency Purchase',
        'Others',
      ],
    };

    return mockData;
  }
);

// Evaluation Status Data Thunk
export const getEvaluationStatusData = createAsyncThunk(
  'dashboardProcurement/getEvaluationStatusData',
  async () => {
    // TODO: Replace with actual API endpoint
    // const response = await fetch('/api/procurement/evaluation-status');
    // const data = await response.json();

    // Mock data for now
    const mockData = {
      series: [34, 27, 39],
      labels: ['Await Evaluation', 'Ready for Evaluation', 'Under Evaluation'],
    };

    return mockData;
  }
);

// Category Data Thunk
export const getCategoryData = createAsyncThunk(
  'dashboardProcurement/getCategoryData',
  async () => {
    // TODO: Replace with actual API endpoint
    // const response = await fetch('/api/procurement/category-summary');
    // const data = await response.json();

    // Mock data for now
    const mockData = {
      series: [
        {
          name: 'Total Procurement',
          data: [156, 89, 67],
        },
      ],
      categories: ['Fuel', 'Petrochemical', 'LPG'],
      totals: {
        fuel: { count: 156, percentage: 50 },
        petrochemical: { count: 89, percentage: 28.5 },
        lpg: { count: 67, percentage: 21.5 },
      },
    };

    return mockData;
  }
);
